import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../Components/Form";
import { CriarConfigEnvelopeController } from "../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";

interface ICriarConfigDeEnvelopeProps {
    idProduto: number;
    onCreate(id: number): void;
}
interface ICriarConfigEnvelopeFormData {
    DS_ENVELOPE: string;
}

export default function CriarConfigDeEnvelope(
    props: ICriarConfigDeEnvelopeProps
) {
    const { execute: cadastrarConfigEnvelope, loading: cadastrando } =
        useAsyncCallback(async (formdata: ICriarConfigEnvelopeFormData) => {
            await CriarConfigEnvelopeController({
                DS_ENVELOPE: formdata.DS_ENVELOPE,
                ID_PRODUTO: props.idProduto,
            }).then((res) => props.onCreate(res.id));
        });

    return (
        <UnForm handleSubmit={cadastrarConfigEnvelope}>
            <UnForm.Input name="DS_ENVELOPE" label="Nome" />
            <UnForm.SubmitButton
                color="success"
                icon={faEnvelope}
                disabled={cadastrando}
                loading={cadastrando}
                loadingSize="sm"
                className="w-100"
                wrapperClassName="p-0 mt-8"
            >
                Criar Configuração de Envelope
            </UnForm.SubmitButton>
        </UnForm>
    );
}
